<template>
    <div class="anthropometrics-summary">

        <div class="container anthropometrics-summary__row">
            <b-row :cols="$mq == 'sm' ? 3 : 6">
                <b-col v-for="(cell,j) in cells" :key="j">
                    <div class="header-cell"
                         :class="{'missing-value': !cell.value}">
                        {{ cell.label }}
                    </div>
                    <div class="value-cell"
                         :class="{'missing-value': !cell.value}">
                        {{ cell.value ? cell.value : '&nbsp;' }}
                    </div>
                </b-col>
            </b-row>
        </div>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

/**
 * A minimalist view showing the values for an Anthropometrics record
 */
export default Vue.extend({
    name: 'AnthropometricsSummary',
    props: {
        anthropometrics: Object
    },
    computed: {
        cells() {
            return [
                {label: 'Weight', value: this.anthropometrics.weight_lb},
                {label: 'Height', value: this.anthropometrics.height_in},
                {label: 'Waist', value: this.anthropometrics.waist_in},
                {label: 'BMI', value: this.bmi},
                {label: 'BP', value: this.bp},
            ]
        },
        bmi() {
            const m = this.anthropometrics.weight_lb / 2.2
            const h = this.anthropometrics.height_in * .0254
            if (!!m && !!h) {
                return (m / (h * h)).toFixed(2)
            } else {
                return null
            }
        },
        bp () {
            return this.anthropometrics.bp_systolic + ' / ' + this.anthropometrics.bp_diastolic
        }
    },
})

</script>

<style lang="scss">
.anthropometrics-summary {
    .header-cell {
        width: 100%;
        min-width: 50px;
        text-align: center;
        background-color: var(--base-color-lighten-30);
        padding-top: 8px;
        padding-bottom: 8px;

        &.missing-value {
            background-color: #ddd;
            color: #999;
        }
    }

    .value-cell {
        width: 100%;
        min-width: 50px;
        text-align: center;
        background-color: transparent;
        border: solid 1px var(--base-color-lighten-30);
        padding-top: 8px;
        padding-bottom: 8px;

        &.missing-value {
            border-color: #ddd;
        }
    }
}

.anthropometrics-summary__row {
    &:first-child {
        padding-bottom: 1em;
    }
}

</style>
